import { getPersistedInfiniteQueryOptions } from '#pplx/frontend/react-query/internal/getPersistedInfiniteQueryOptions.js';
import { useQueryClientProviderConfig } from '#pplx/frontend/react-query/QueryClientProviderContext.js';
import { useInfiniteQuery as useReactInfiniteQuery, useQueryClient } from '@tanstack/react-query';
export function useInfiniteQuery(options, queryClient) {
    let reactQueryClient = useQueryClient();
    if (queryClient)
        reactQueryClient = queryClient;
    const { allowPersist } = useQueryClientProviderConfig();
    return useReactInfiniteQuery(getPersistedInfiniteQueryOptions({ options, queryClient: reactQueryClient, allowPersist }), queryClient);
}
//# sourceMappingURL=useInfiniteQuery.js.map